import React, { useState } from 'react'

import { FeedbackModal } from 'cube/components/FeedbackModal'

import { Button } from '@driftt/dds'
import { faBullhorn } from '@driftt/dds.icons/light/faBullhorn'

export const MeetingBookingReportFeedbackModal: React.FC = () => {
  const [feedbackOpen, setFeedbackOpen] = useState<boolean>(false)

  return (
    <>
      <Button
        variant={'education'}
        onClick={() => setFeedbackOpen(true)}
        size={'medium'}
      >
        <Button.Icon icon={faBullhorn} />
        Give feedback
      </Button>
      <FeedbackModal
        open={feedbackOpen}
        onClose={() => setFeedbackOpen(false)}
        title="Meetings app reporting feedback"
        trackingEventName="SC-meeting-booking-app-reporting-feedback"
        easeOfUseQuestionLabel="How difficult or easy is it to understand how search is performing? (optional)"
        sentimentQuestionLabel="How disappointed would you be if you no longer had search on your website? (optional)"
        feedbackQuestionLabel="Please share any feedback related to meeting booking reporting"
      />
    </>
  )
}
